import { action, computed, makeObservable } from "mobx";
import { userInfoStore } from "Stores/UserInfoStore";
import { projectsDataStore } from "Stores/ProjectsStore";
import { tasksDataStore } from "./TasksDataStore";
import { taskGroupStore } from "./TaskGroupStore";
import { ObjectDataStore } from "Stores/RESTStoreInstances/ObjectDataStore";
import { API_URL } from "General/APIEndpoints";
import { handleStoreState } from "Stores/RESTStore/CoreStore";
import i18n, { I18N_NS } from "Config/i18n";
import { UploadFile } from "antd/lib/upload/interface";

export interface TaskUploadFile extends UploadFile {
  id?: string | number;
  deleted?: boolean;
  accessLevel?: API_FILEATTACHMENT_ACCESSLEVEL;
  viewers?: API_FileDataEntity["viewers"];
  fileActions?: API_FileDataEntity["fileActions"];
}

export class TaskDataStore extends ObjectDataStore<API_TaskData> {
  constructor() {
    super();

    makeObservable(this, {
      taskList: computed,
      taskId: computed,
      isOwner: computed,
      getTaskById: action.bound,
    });

    this.data = {};
  }

  url(taskId?: number) {
    if (taskId) {
      return API_URL.TASKS.getTask(projectsDataStore.projectId, taskId);
    } else {
      return API_URL.TASKS.createTask(projectsDataStore.projectId);
    }
  }

  @handleStoreState()
  async getTaskById(id: number, force = false) {
    if (force) {
      await this.fetch({}, id);
    } else {
      const result = tasksDataStore.data.find((item) => item.id === id) as API_TaskData;
      if (result) {
        this.data = result;
      } else {
        await this.fetch({}, id);
      }
    }
  }

  get taskList() {
    return (
      taskGroupStore.findList(+this.data.listId) || {
        name: i18n.t("unassigned", { ns: I18N_NS.PROJECT }),
        id: -1,
      }
    );
  }

  get taskId() {
    return Object.prototype.hasOwnProperty.call(this.data.hasOwnProperty, "id") ? this.data.id : null;
  }

  get isOwner() {
    return this.data.ownerId === userInfoStore.id;
  }
}

export const taskDataStore = new TaskDataStore();
